<template>
  <section class="fill-height align-center justify-center">
    <div v-if="!$smallScreen" class="floating-corner-btn">
      <v-btn @click="changeView" rounded outlined class="secondary-color">
        {{ mode }}
        <v-icon small>mdi-tumblr-reblog</v-icon>
      </v-btn>
    </div>
    <div v-if="mode === 'Desktop'" class="fill-height">
       <MobileDemoView />
    </div>
    <div v-if="mode === 'Mobile'" class="fill-height">
       <Cashier />
    </div>
  </section>
</template>

<script>
import Cashier from '@/components/Cashier'
import MobileDemoView from '@/components/MobileDemoView'

export default {
  name: 'Demo-page',
  components: {
    Cashier,
    MobileDemoView
  },
  data: () => ({
    msg: null,
    mode: 'Mobile'
  }),
  methods: {
    changeView () {
      switch (this.mode) {
        case 'Mobile':
          this.mode = 'Desktop'
          break
        case 'Desktop':
        default:
          this.mode = 'Mobile'
          break
      }
      this.setToLocalStorage()
    },
    setToLocalStorage (type) {
      localStorage.setItem('DEMO_DISPLAY_MODE', this.mode)
    }
  },
  created () {
    const savedDemoMode = localStorage.getItem('DEMO_DISPLAY_MODE')
    if (savedDemoMode) {
      this.mode = savedDemoMode
    } else {
      this.setToLocalStorage()
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.floating-corner-btn {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 200;
}
</style>
